export default "__VITE_ASSET__Bty7E3fl__"